import { render, staticRenderFns } from "./FlowDetails.vue?vue&type=template&id=4d332460&scoped=true"
import script from "./FlowDetails.vue?vue&type=script&lang=js"
export * from "./FlowDetails.vue?vue&type=script&lang=js"
import style0 from "./FlowDetails.vue?vue&type=style&index=0&id=4d332460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d332460",
  null
  
)

export default component.exports